var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSalesOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 22.75A5.75 5.75 0 1 1 22.75 17 5.757 5.757 0 0 1 17 22.75zm0-10A4.25 4.25 0 1 0 21.25 17 4.255 4.255 0 0 0 17 12.75z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.75H4A2.752 2.752 0 0 1 1.25 20V4A2.752 2.752 0 0 1 4 1.25h12A2.752 2.752 0 0 1 18.75 4v8.1a.75.75 0 1 1-1.5 0V4A1.252 1.252 0 0 0 16 2.75H4A1.252 1.252 0 0 0 2.75 4v16A1.252 1.252 0 0 0 4 21.25h12a.948.948 0 0 0 .229-.021.764.764 0 0 1 .926.731.746.746 0 0 1-.643.743 2.521 2.521 0 0 1-.512.047z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 7.75H6a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 0 1.5zM11 11.75H6a.75.75 0 0 1 0-1.5h5a.75.75 0 0 1 0 1.5zM16.5 18.75a.744.744 0 0 1-.53-.22l-1-1a.75.75 0 1 1 1.06-1.06l.47.469 1.47-1.469a.75.75 0 1 1 1.06 1.06l-2 2a.744.744 0 0 1-.53.22z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesOrder);
export default __webpack_public_path__ + "static/media/sales-order.efb97bf0e3b471c345eba3cbd696ad00.svg";
export { ForwardRef as ReactComponent };